import {useEffect, useState} from 'react';
// import { Bar } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

const VerticalBar = ({data}) => {
	const [filteredData, setFilteredData] = useState({labels: [], datasets: []});
	

	useEffect(() => {
		if (data && data[0] !== undefined) {
			let dataset = [];
			for (let i = 0; i < data.length; i++) {
				if (!data[i].EjeY) continue;
				const element = data[i].EjeY.split('|');
				const label = ["Programado", "Valorizado", "Real" ].indexOf(element[0]) >= 0 
								? element[0]
								: 'labels';
				dataset[label] = element.slice(label === "labels" ? 0 : 1);
			}
		
			const filteredData = {
				labels: dataset["labels"] ? dataset["labels"] : [],
				//  data && data[0] !== undefined ? data[0].EjeY.split('|') : [],
				
				datasets: [
				  {
					label: "Programado",
					data: dataset["Programado"] ? dataset["Programado"] : [],
					fill: false,
					backgroundColor: "#367fa9",
					borderColor: "#367fa9",
				  },
				  {
					label: "Valorizado" ,
					data: dataset["Valorizado"] ? dataset["Valorizado"] : [],
					fill: false,
					backgroundColor: "#E1C340",
					borderColor: "#f2a744",
				  },
			  
				  {
					label: "Real" ,
					data: dataset["Real"] ? dataset["Real"] : [],
					fill: true,
					backgroundColor: "#36bea1 ",
					borderColor: "#36bea1",
				  },
				],
			};
			setFilteredData(filteredData);
		}
	}, [data]);
	
	  
	  const options = {
		plugins:{
			legend:{
				display: false
			}
		},
		scales: {
		  yAxes: [
			{
			  ticks: {
				beginAtZero: true,
			  },
			},
		  ],
		},
	  };

	return(
		<div className="responsive-chart">
			<Bar data={filteredData} options={options} className="maxandmin"  />
		</div>
	);
}

export default VerticalBar;